import React, { useState } from "react";
import { faqs } from "../mock/data";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 md:px-8">
        <div className="text-center">
          <div className="section-eyebrow">Patient FAQs</div>
          <h2 className="mt-4 font-serif-display text-[40px] md:text-[58px] leading-[1.05] text-[#0e2b2b]">
            Quick answers before <span className="hero-italic">your visit</span>
          </h2>
        </div>

        <div className="mt-12 divide-y divide-[#0e2b2b]/10 border-y border-[#0e2b2b]/10">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="font-serif-display text-[22px] md:text-[26px] text-[#0e2b2b]">{f.q}</span>
                  <span className={`w-10 h-10 shrink-0 rounded-full flex items-center justify-center transition-colors ${isOpen ? "bg-[#14a68e] text-white" : "bg-[#0e2b2b]/5 text-[#0e2b2b]"}`}>
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div
                  className="overflow-hidden transition-all duration-300 ease-out"
                  style={{ maxHeight: isOpen ? 200 : 0 }}
                >
                  <p className="pb-6 pr-14 text-[15px] md:text-[16px] text-[#0e2b2b]/70 leading-relaxed">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
